const DEFAULT_CHART_STRATEGY = "analogous";
const STATUS_KEYS = ["success", "warning", "danger", "info"];

const chartThirdIndex = (value) =>
  value && /^[0-6]$/.test(value) ? Number(value) : 0;

// Callers supply DS constants so this browser-safe mapper never loads a second DS bundle.
function resolveBrandIdentity(
  companyColors,
  platformColors,
  { base, chartStrategies },
) {
  const pick = (key) =>
    companyColors?.[key] || platformColors?.[key] || undefined;
  const primary = pick("primary");
  const secondary = pick("secondary");
  const tertiary = pick("tertiary");
  const background = pick("navBackground");
  const status = Object.fromEntries(
    STATUS_KEYS.filter((key) => pick(key)).map((key) => [key, pick(key)]),
  );
  const strategy = pick("chartStrategy");
  const chartStrategy = chartStrategies.includes(strategy)
    ? strategy
    : undefined;
  const leadWithSecondary = pick("chartLeadWithSecondary") === "true";
  const third = chartThirdIndex(pick("chartThirdColor"));

  if (
    !primary &&
    !secondary &&
    !tertiary &&
    !background &&
    Object.keys(status).length === 0 &&
    !chartStrategy &&
    !leadWithSecondary &&
    !third
  ) {
    return undefined;
  }

  return {
    primary: primary ?? base.primary,
    secondary: secondary ?? base.secondary,
    tertiary: tertiary ?? base.tertiary,
    ...(background ? { background } : {}),
    ...(Object.keys(status).length > 0 ? { status } : {}),
    chart: {
      strategy: chartStrategy ?? DEFAULT_CHART_STRATEGY,
      leadWithSecondary,
      ...(third ? { third } : {}),
    },
  };
}

module.exports = {
  DEFAULT_CHART_STRATEGY,
  chartThirdIndex,
  resolveBrandIdentity,
};
